import { render, staticRenderFns } from "./MyStampCards.vue?vue&type=template&id=33ad5d77&"
import script from "./MyStampCards.vue?vue&type=script&lang=js&"
export * from "./MyStampCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports